/*
 fetch_fees_and_limits
 */
import actions from '../../common/lib/utils/actions.js';
import constants from '../../common/lib/utils/constants.js';
import core from '../../common/lib/core.js';
import dataflow from '../../common/lib/dataflow.js';
import view from './view.js';
import methodConfig from './deposit-form-template-conf.js';

const state = {
	depositLimitsAndFeesData: null,
	bonusId: '',
	bonus_condition: '',
	bonusPaymentMethods: ''
};

const presetIndex = 0; // Siru for example preselects the first value in the defaultlist
const register = dataflow.register;
let requestUrl = null;
let fetchAgainForPresetAmount = false;

function viewUpdate() {
	view.update({
		fetch_fees_and_limits: state
	});
}

function checkAmountLimits(amount, max, min) {
	const am = ((amount || amount === 0) ? Number(amount) : 0);
	const maxLimit = ((max || max === 0) ? Math.floor(Number(max)) : 0); // round down max limit
	const minLimit = ((min || min === 0) ? Math.ceil(Number(min)) : 0); // round up min limit
	const validRange = (minLimit < maxLimit);
	const within = (validRange && am && am <= maxLimit && am >= minLimit);
	const above = (validRange && am > maxLimit);
	const below = (validRange && am < minLimit);
	const aboveIsZero = (maxLimit === 0); // a convention used on the desktop site when the higher limit is zero
	/* returns booleans */
	return {
		above,
		below,
		within,
		aboveIsZero
	};
}

function filterFrom(filterThis, from) {
	let filtered;
	if (filterThis && filterThis.replace) {
		filtered = filterThis.replace(from, '');
	} else {
		filtered = '';
	}
	return filtered;
}

function equalsNumber(str) {
	const num = new RegExp(/^[0-9]+/g);
	return ((str && str.match) && str.match(num));
}

function formatAmountList(amountselectlist, selectedindex) {
	/*
	parse the format of
{PARAM_AMOUNT1: 35, PARAM_AMOUNT2: 70 ..., PARAM_AMOUNT_NUM: valN, currency:'kr'}
to {1:{value:35:text:'35 kr'}}
Select the indexes with keys PARAM_AMOUNT1:value1...PARAM_AMOUNT_N:value2 and add its value to an array
*/
	const amounts = [];
	let str;
	let text;
	const currency = ((amountselectlist && amountselectlist.PARAM_CURRENCY) || null);
	Object.keys(amountselectlist).forEach((index) => {
		/* A reference to the element is saved. */
		/* The uninserted nodes are returned as a list to be inserted with 'nodetree'-function. */
		str = index;
		str = filterFrom(str, 'PARAM_AMOUNT');
		if (equalsNumber(str)) {
			text = `${amountselectlist[index]} ${currency}`;
			amounts.push({
				value: amountselectlist[index],
				text
			});
		}
	});
	if (amounts[selectedindex]) {
		amounts[selectedindex].selected = true;
	}
	return amounts;
}

function parseToState(data) {
	/* the response is filtered here instead of in the view. */
	const bonus = data && data.bonusAmountsData;
	const limit = data && data.depositLimitData;
	const defaultDepositAmounts = data && data.defaultDepositAmounts;
	const fee = data && data.depositFeeAmounts;
	const newBalance = (data && data.newBalance);
	const limitMax = (limit && limit.PARAM_MAX_OPERATION);
	const limitMin = (limit && limit.PARAM_MIN_OPERATION);
	// const depositLimitReached = (parseInt(limitMax,10) === 0);
	// const feeBasedOn = (fee && fee.PARAM_AMOUNT);
	const limitCheck = checkAmountLimits(state.feeBasedOn, limitMax, limitMin);
	/* Bonusfield: conditions: when bonusamount is calculated from conditions
	build from percentage and max/min-values */
	const bonusCondition = (data && data.bonus_condition);
	state.bonusAmount = (bonus && bonus.PARAM_BONUS_AMOUNT);
	state.bonus_condition = bonusCondition;
	state.bonusTotal = (bonus && bonus.PARAM_BONUS_TOTAL);
	state.bonusWasFound = (bonus && bonus.bonusWasFound);
	state.defaultAmounts = defaultDepositAmounts;
	// state.feeBasedOn = feeBasedOn;
	state.fee = (fee && fee.PARAM_FEE);
	state.feeUnit = (fee && fee.PARAM_FEE_EXT);
	state.feeAmount = (fee && fee.PARAM_FEE_AMOUNT);
	state.feeEnabled = (fee && fee.PARAM_FEE_TYPE);
	state.feeRate = (fee && fee.PARAM_RATE);
	state.feeSumAmount = (fee && fee.PARAM_TOTAL_AMOUNT);
	state.limitFee = limit.PARAM_FEE_LIMIT;
	state.limitMax = limitMax;
	state.limitMin = limitMin;
	state.playerCurrency = limit.PARAM_PLAYER_CURRENCY;
	state.selectedCurrency = limit.PARAM_CURRENCY_ISO;
	state.limitResponsiveGaming = limit.PARAM_RESPONSIBLE_GAMING_LIMIT;
	state.newBalance = newBalance;
	state.limitWithin = limitCheck.within;
	state.limitAbove = limitCheck.above;
	state.limitBelow = limitCheck.below;
	state.limitReached = limitCheck.aboveIsZero;
	state.defaultAmountsFormatted = formatAmountList(defaultDepositAmounts, presetIndex);
}

function doesSelectedMethodExistInBonusPaymentMethods(selectedMethodId) {
	return state.bonusPaymentMethods.split(',').indexOf(selectedMethodId.toString()) > -1;
}

function resolveBonusIdFromValidBonusPaymentMethods(p) {
	const selectedMethodId = ((p && p.paymentMethodId) || state.paymentMethodId);
	if (state.bonusPaymentMethods && selectedMethodId && (doesSelectedMethodExistInBonusPaymentMethods(selectedMethodId) || state.bonusPaymentMethods === 'ALL')) {
		return ((p && p.bonusId) ? p.bonusId : state.bonusId);
	}
	return null;
}

function getDataAndAddToState(p, repeatFetchCb, validateFeesAndLimitsPromiseResolver) {
	const params = {
		paymentMethodId: ((p && p.paymentMethodId) || state.paymentMethodId),
		creditCardNumber: ((p && p.creditCardNumber) || state.cardNo),
		playerCardId: ((p && (p.playerCardId || p.playerCardId === 0)) ? p.playerCardId : state.playerCardId),
		amount: ((p && p.amount) || state.amount),
		isMobileDevice: true,
		isInstantDeposit: false,
		currency: ((p && p.currency) ? p.currency : state.selectedCurrency),
		bonusId: resolveBonusIdFromValidBonusPaymentMethods(p)
	};
	state.feeBasedOn = params.amount;
	const jQueryParams = jQuery.param(params); // What does this do? http://api.jquery.com/jquery.param/
	function successHandler(data) {
		state.error = false;
		state.pending = false;
		parseToState(data);
		if (repeatFetchCb) {
			/* resend the request */
			repeatFetchCb();
		} else {
			actions.fetchFeesAndLimits(state);
			viewUpdate();
			if (validateFeesAndLimitsPromiseResolver) {
				validateFeesAndLimitsPromiseResolver('feesAndLimitsValidatedAtSubmit');
			}
		}
	}

	function errorHandler(err) {
		console.error('fetch_fees_and_limits:57:error:', err);
		state.pending = false;
		state.error = true;
	}
	if (params.paymentMethodId) {
		// Also fetch defaultAmounts from getDepositFeesAndLimits even in case of amount = 0
		// core.post(requestUrl, jQuery.param(params), (data) => {
		/* update the view to inform about a new request is send*/
		state.pending = true;
		state.error = false;
		viewUpdate();
		core.post(requestUrl, jQueryParams, successHandler, errorHandler, 'application/x-www-form-urlencoded; charset=UTF-8');
	}
}

function registerActions() {
	function fetchFeesAndLimits(payload) {
		let data;
		let amount;
		if (payload.type === constants.FETCH_METHODDETAILS) {
			/* details from a possible earlier used account */
			// TODO:if a new method is selected which differs from the last, then only use new amount and method.
			let lastAmount = ((payload.data && payload.data.lastAmount) || state.lastAmount);
			const selectedAccountIdx = payload.data.selectedAccountIdx;
			const paymentAccounts = payload.data.accounts;
			if (lastAmount && state.amountManuallyAdded) {
				lastAmount = state.amountManuallyAdded;
			}
			state.cardNo = (payload.data && payload.data.creditcardlast);
			state.playerCardId = (payload.data && payload.data.lastCardId);
			state.accountId = ((payload.data && (payload.data.accountId || payload.data.accountId === 0)) ? payload.data.accountId : null);
			state.amount = lastAmount;

			// if a last amount exists and payment method has currency selector, then update its selected currency with last selected currency
			if (selectedAccountIdx != null && paymentAccounts != null && Array.isArray(paymentAccounts)) {
				state.selectedCurrency = paymentAccounts[selectedAccountIdx].cu;
			}

			/*  messy but the intention is to fetch the fees and limits for a preset amount, which is
			retrieved with data from the first request. This shall only be done when the method is selected
			or re-selected */
			let repeatForPresetAmountCb = null;
			if (fetchAgainForPresetAmount) {
				fetchAgainForPresetAmount = false;
				repeatForPresetAmountCb = function cb() {
					const presetAmount = ((((state && state.defaultAmountsFormatted) && state.defaultAmountsFormatted[presetIndex]) && state.defaultAmountsFormatted[presetIndex].value) || null);
					state.amount = presetAmount;
					state.amountManuallyAdded = presetAmount;
					state.presetIndex = presetIndex;
					getDataAndAddToState({
						creditCardNumber: state.cardNo,
						playerCardId: state.playerCardId,
						accountId: state.accountId,
						amount: presetAmount,
						currency: state.selectedCurrency,
						bonusId: state.bonusId
					});
				};
			}
			getDataAndAddToState({
				creditCardNumber: state.cardNo,
				playerCardId: state.playerCardId,
				accountId: state.accountId,
				amount: lastAmount,
				currency: state.selectedCurrency || state.lastCurrency, // if a last amount exists, the lastCurrency has the unit for a new fees-and-limit request
				bonusId: state.bonusId
			}, repeatForPresetAmountCb);
		}
		if (payload.type === constants.PAYMENTMETHODS) {
			/* payload.data && payload.data.amountmanuallyset shall override other methods and
			 only be adjusted by the limits.*/
			state.paymentMethodId = (payload.data && payload.data.selectedId);
			state.lastAmount = (payload.data && payload.data.lastAmount);
			state.lastCurrency = (payload.data && payload.data.lastCurrency);
			state.playerCurrency = (payload.data && payload.data.playerCurrency);
			if (methodConfig.displayAmountSelector()) {
				fetchAgainForPresetAmount = true;
			}
			if (payload.data.lastCurrency && payload.data.selectedId === payload.data.lastUsedMethodId &&
				methodConfig.displayCurrencySelector(payload.data.methods.by_id[payload.data.selectedId].formTemplateCode)) {
				state.selectedCurrency = state.lastCurrency;
			} else {
				state.selectedCurrency = state.playerCurrency;
			}
		}
		if (payload.type === constants.VIEW_CURRENCYSELECT) {
			// TODO: update backend service(?) to update from currency which happens for some paymentmethods (skrill)
			state.selectedCurrency = payload.data;
			getDataAndAddToState();
		}
		if (payload.type === constants.VIEW_METHODS) {
			// method changed by user: reset parameters and wait for paymentMethods to update.
			// There will be a new payload of FETCH_METHODDETAILS comming, then we fetch fees and limits
			// The update of method is set by paymentmethods-module.
			state.paymentMethodId = null;
			state.cardNo = null;
			state.playerCardId = null;
			state.selectedCurrency = null;
		}

		if (payload.type === constants.VIEW_CREDITCARDLAST) {
			data = payload.data;
			state.playerCardId = data.cardid;
			state.cardNo = data.cn;
			getDataAndAddToState();
		}

		if (payload.type === constants.VIEW_CREDITCARDNEW) {
			data = payload.data;
			state.cardNo = data;
			state.playerCardId = null;
			getDataAndAddToState({
				amount: (state.amount || state.lastAmount)
			});
		}
		if (payload.type === constants.VIEW_AMOUNTINPUT && payload.data) {
			/* The paymentforms amount-input is updated and the fee has to be compared to the amount.
			    start or stop a timer to compare when the call was last done.
			    The view_paymentform dispatches actions each time a new value is typed into the field.
			    count number of calls to the getDataAndReplaceState-function
			    check timer to see when last call was done.
			    if time was less than x-milliseconds then add to the counter and wait for more input
			    if more input is recieved then wait further, and when wait is over call for the las recieved amount.
	        */
			amount = ((payload.data.amount || payload.data.amount === 0) ? payload.data.amount : null);
			if (amount) {
				state.amount = amount;
				state.amountManuallyAdded = amount; // overrides other amounts until adjusted by limits
				if (!state.limitReached) {
					getDataAndAddToState();
				}
			}
		}
		if (payload.type === constants.VIEW_AMOUNTSELECT) {
			state.amount = (payload.data && payload.data.amount);
			state.amountManuallyAdded = (payload.data && payload.data.amount);
			getDataAndAddToState();
		}
		// if (payload.type === constants.VIEW_PAYMENTFORM) {
			// console.log('fetch_fees_and_limits:VIEW_PAYMENTFORM', payload);
			// setupmethod
		// }
		if (payload.type === constants.BONUSES) {
			/* Confirmed selected bonus. */
			if (payload.data && {}.hasOwnProperty.call(payload.data, 'selected') && {}.hasOwnProperty.call(payload.data.selected, 'id')) {
				state.bonusId = payload.data.selected.id;
			}
			if (payload.data && payload.data.selected && payload.data.selected.validPaymentMethods) {
				state.bonusPaymentMethods = payload.data.selected.validPaymentMethods;
			}

			if (payload.data && payload.data.condition) {
				state.bonus_condition = payload.data.condition;
			}
			// We could skip this extra fetch of fees and limits if fetch_fees_and_limits is initialized before bonus is selected,
			// because then we would already have the bonusId when fetching fees and limits after call to get form template data
			getDataAndAddToState();
		}

		if (payload.type === constants.VALIDATE_FEES_AND_LIMITS_AT_SUBMIT) {
			const validateFeesAndLimitsPromiseResolver = payload.data;
			getDataAndAddToState(null, null, validateFeesAndLimitsPromiseResolver);
		}
	}

	register(fetchFeesAndLimits);
}

export default {
	init(url) {
		if (url) {
			requestUrl = url;
		} else {
			console.error('fetch_fees_and_limits:89:init: no url provided', url);
		}
		registerActions();
	},
	__testCheckAmountLimits(amount, max, min) {
		return checkAmountLimits(amount, max, min);
	},
	__testCheckFormatAmountList(obj, currency) {
		return formatAmountList(obj, currency);
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/fetch-fees-and-limits.js